var _rect, _path, _circle, _circle2, _rect2, _rect3, _text, _rect4, _rect5, _rect6, _text2, _text3, _text4, _path2, _path3, _path4, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniconvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 132,
    r: 230,
    fill: "#2DD4BF",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 620,
    r: 270,
    fill: "#FB7185",
    opacity: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 114,
    width: 928,
    height: 532,
    rx: 36,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 162,
    width: 218,
    height: 54,
    rx: 14,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 198,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "UniConvert")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 284,
    width: 268,
    height: 270,
    rx: 32,
    fill: "rgba(45,212,191,.12)",
    stroke: "rgba(45,212,191,.4)",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 284,
    width: 268,
    height: 270,
    rx: 32,
    fill: "rgba(245,158,11,.12)",
    stroke: "rgba(245,158,11,.36)",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 814,
    y: 284,
    width: 170,
    height: 270,
    rx: 32,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.13)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 344,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "Time")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 344,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "Money")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 344,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "Units")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284 430h126M382 400l34 30-34 30",
    stroke: "#2DD4BF",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M584 432h126M682 402l34 30-34 30",
    stroke: "#F59E0B",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M858 432h66",
    stroke: "#CBD3DE",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 488,
    width: 164,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 488,
    width: 164,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 488,
    width: 80,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 584,
    width: 828,
    height: 18,
    rx: 9,
    fill: "rgba(255,255,255,.12)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 584,
    width: 712,
    height: 18,
    rx: 9,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniconvert);
export default __webpack_public_path__ + "static/media/uniconvert.a714ffeb2fb5f014fe13f620fb9af613.svg";
export { ForwardRef as ReactComponent };